export default "__VITE_ASSET__C29Qr3tO__"